///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Routes } from '@angular/router';
import { GtthUsersComponent } from './users/users.component';
import { UserAuthorities } from '../services/user/user-authorities';

const pageTitle = 'customer.home.title';

export const USERS_BASE_URL = 'users';

export const usersRoute: Routes = [
    {
        path: '',
        component: GtthUsersComponent,
        data: {
            tabName: USERS_BASE_URL,
            authorities: [UserAuthorities.COMPANY_ADMIN],
            pageTitle
        },
        title: 'Users'
    }
];
